import { AuthState } from '@okta/okta-auth-js';
import axios from 'axios';
import BaseService from './baseService';

export interface ReleaseNoteResponse {
    id: number;
    tagName: string;
    name: string;
    body: string;
    publishedAt: string;
}

export default class ReleaseNotesService extends BaseService {
    constructor() {
        super();
    }

    public async getReleases(authState: AuthState | null): Promise<ReleaseNoteResponse[]> {
        const response = await axios.get<ReleaseNoteResponse[]>(
            `${this.REACT_APP_API_BASE_URL}/release-notes`,
            this.getHeaders(authState)
        );
        return response.data;
    }
}
